import { render, staticRenderFns } from "./ModeloCreate.vue?vue&type=template&id=3d86cb2c&scoped=true&"
import script from "./ModeloCreate.vue?vue&type=script&lang=js&"
export * from "./ModeloCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86cb2c",
  null
  
)

export default component.exports